import BigNumber from 'bignumber.js'
import React from 'react'
import { cell_user_nolive } from '../Cell/user'

export const column_balance_prev = (mutate, showModal) => {
	return [
		{
			title: '그룹',
			dataIndex: 'referral_code',
			key: 'referral_code',
			align: 'center',
			width: 100,
		},
		cell_user_nolive(mutate, showModal, 'id'), //회원
		{
			title: '입금총액',
			align: 'center',
			children: [
				{
					title: '일반입금',
					dataIndex: 'total_deposit_amount',
					key: 'total_deposit_amount',
					align: 'center',
					width: 150,
					render: (text, data) => {
						//return <KrwPrice price={Math.abs(text)} />
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '별도입금',
					dataIndex: 'total_deposit_amount_extra',
					key: 'total_deposit_amount_extra',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={Math.abs(text)} />
					// },
				},
				{
					title: '코인>해선',
					dataIndex: 'total_deposit_amount_move',
					key: 'total_deposit_amount_move',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={Math.abs(text)} />
					// },
				},
			],
		},
		{
			title: '출금총액',
			align: 'center',
			children: [
				{
					title: '일반출금',
					dataIndex: 'total_withdraw_amount',
					key: 'total_withdraw_amount',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(-text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={-Math.abs(text)} />
					// },
				},
				{
					title: '별도출금',
					dataIndex: 'total_withdraw_amount_extra',
					key: 'total_withdraw_amount_extra',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(-text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={-Math.abs(text)} />
					// },
				},
				{
					title: '해선>코인',
					dataIndex: 'total_withdraw_amount_move',
					key: 'total_withdraw_amount_moove',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(-text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={-Math.abs(text)} />
					// },
				},
			],
		},
		{
			title: '손익현황',
			align: 'center',
			children: [
				{
					title: '총매매손익',
					dataIndex: 'total_pnl_price',
					key: 'total_pnl_price',
					align: 'center',
					width: 150,
					rowScope: 'row',
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={text} />
					// },
				},
				{
					title: '수수료',
					dataIndex: 'total_fee_price',
					key: 'total_fee_price',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(-text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={-Math.abs(text)} />
					// },
				},
				{
					title: '실현손익',
					dataIndex: 'total_trade_price',
					key: 'total_trade_price',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
					// render: (text, data) => {
					// 	return <KrwPrice price={text || 0} />
					// },
				},
			],
		},
		{
			title: '마지막잔액',
			align: 'center',
			children: [
				{
					title: '예수금',
					dataIndex: 'last_balance',
					key: 'last_balance',
					align: 'center',
					width: 150,
					render: (text, data) => {
						return (
							<div
								className={
									(data?.warn ? 'warn ' : '') +
									(+text > 0
										? 'plus'
										: +text < 0
										? 'minus'
										: '') +
									' krw'
								}>
								{new BigNumber(text || 0).toFormat(0)}
							</div>
						)
					},
				},
				{
					title: '전일비교',
					dataIndex: 'prev_balance',
					key: 'prev_balance',
					align: 'center',
					width: 150,
					sorter: (a, b) => a.diff - b.diff,
					render: (text, data) => {
						const calc = new BigNumber(+text || 0)
							.plus(
								Math.abs(data?.total_deposit_amount || 0) || 0
							)
							.plus(data?.total_deposit_amount_extra || 0)
							.plus(data?.total_deposit_amount_move || 0)
							.minus(
								Math.abs(data?.total_withdraw_amount || 0) || 0
							)
							.minus(
								Math.abs(
									data?.total_withdraw_amount_extra || 0
								) || 0
							)
							.minus(
								Math.abs(
									data?.total_withdraw_amount_move || 0
								) || 0
							)
							.plus(data?.total_trade_price || 0)
							.toNumber()
						const diff = Math.floor(
							Math.abs(calc - data?.last_balance)
						)
						data.diff = diff
						if (diff > 0.9) {
							data.warn = true
							return (
								<div>
									<div className={'warn krw'}>
										{new BigNumber(text || 0).toFormat(0)}
									</div>
									<div
										className={'krw minus'}
										style={{
											backgroundColor: 'black',
										}}>
										{new BigNumber(diff).toFormat(0)}
									</div>
								</div>
							)
						} else {
							data.warn = false
							return (
								<div className={'krw'}>
									{new BigNumber(text || 0).toFormat(0)}
								</div>
							)
						}
					},
				},
			],
		},
	]
}
